import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import GlobalError from "@/components/errors/GlobalError";

// ---------------------- Component

const Layout = () => {
  // --------- Variables / Hooks

  // Auth is complete and user data is available — remove the full-screen loading overlay
  useEffect(() => {
    document.getElementById("app-loading-overlay")?.remove();
  }, []);

  // --------- JSX

  return (
    <div className="h-full flex-1 overflow-auto">
      <Outlet />
      <GlobalError />
    </div>
  );
};

export default Layout;
